import { detectIE } from './detect-ie';
import { recognizeAngularType, RtDebugAngularType } from './rt-debug-recognizer';
import { RtDebugOptions, RtDebugService } from './rt-debug-service';

const noop = (o: any) => o;
let rtDebugService: RtDebugService;

export function RtDebug(options: RtDebugOptions = {}): any {
  if (!options.enabled || detectIE()) {
    return noop;
  }

  if (!rtDebugService) {
    rtDebugService = new RtDebugService();
  }

  return function (originalClass: new () => any): any {
    return rtDebugService.makeClassDebuggable(originalClass, {
      namespace: options.namespace || originalClass.name,
      log: {
        lifecycle: false,
        warnIfNotSingleton:
          (options.log && options.log.warnIfNotSingleton) ||
          recognizeAngularType(originalClass) === RtDebugAngularType.Injectable,
      },
      ...options,
    });
  };
}
